module.exports = "//public.zight.com/packs/media/images/icons-sales-729cddf96ca129d90f2d4b8480d28746.svg";